/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 10
// module chunks = 11